<template>
    <div class="pa-1">
        <v-form
                ref="settingsForm"
                v-model="validSettings">
            <v-row>
                <v-col cols="12" md="6">
                    <v-row>
                        <v-col class="pb-0" cols="12">
                            <v-text-field
                                    v-model="organization.Name"
                                    :rules="[$validations.required]"
                                    class="mb-2"
                                    required
                                    @keyup.enter="saveOrganization">
                                <template v-slot:label>
                                    {{ $t('authentication.subscriptionName') }}<sup>*</sup>
                                </template>
                            </v-text-field>
                            <v-menu :close-on-content-click="false" absolute right>
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="organization.BackgroundColor"
                                            :rules="[$validations.required, $validations.hexColor]"
                                            append-icon="mdi-palette"
                                            class="mb-2"
                                            readonly
                                            required
                                            @keyup.enter="saveOrganization"
                                            @click:append="on.click">
                                        <template v-slot:label>
                                            {{ $t('settings.accentColor') }}<sup>*</sup>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-color-picker
                                        v-model="organization.BackgroundColor"
                                        dot-size="25"
                                        swatches-max-height="200"
                                ></v-color-picker>
                            </v-menu>
                            <v-menu :close-on-content-click="false" absolute right>
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="organization.Color"
                                            :rules="[$validations.required, $validations.hexColor]"
                                            append-icon="mdi-palette"
                                            class="mb-2"
                                            required
                                            @keyup.enter="saveOrganization"
                                            @click:append="on.click">
                                        <template v-slot:label>
                                            {{ $t('settings.textAccentColor') }}<sup>*</sup>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-color-picker
                                        v-model="organization.Color"
                                        dot-size="25"
                                        swatches-max-height="200"
                                ></v-color-picker>
                            </v-menu>
                            <v-autocomplete
                                    v-model="organization.Timezone"
                                    :items="timezones"
                                    :label="$t('settings.timezone')"
                                    :rules="[$validations.required]"
                                    item-text="DisplayName"
                                    item-value="Id"
                                    @keyup.enter="saveOrganization"/>
                        </v-col>
                    </v-row>
                </v-col>
                <input ref="file" hidden type="file" @change="uploadFile"/>
                <v-col class="pb-8 pb-md-0 justify-center d-flex" cols="12" md="6">
                    <v-menu absolute bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <template v-bind="attrs"
                                      v-on="on">
                                <template>
                                    <img
                                            v-show="organization.LogoUrl"
                                            :src="organization.LogoUrl"
                                            alt="avatar"
                                            class="organization-logo align-self-center"
                                            v-bind="attrs"
                                            v-on="on">
                                </template>

                                <v-btn v-show="!organization.LogoUrl" class="align-self-center" size="200"
                                       @click="$refs.file.click()">
                                    {{ $t('settings.uploadLogo') }}
                                </v-btn>
                            </template>
                        </template>
                        <v-list class="px-2" tile>
                            <v-list-item
                                    link
                                    @click="$refs.file.click()">
                                <v-list-item-title>{{ $t('settings.changeLogo') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                    link
                                    @click="removeLogo">
                                <v-list-item-title>{{ $t('settings.removeLogo') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!isResetForm"
                            class="elevation-5  secondary--text mr-3"
                            color="primary"
                            large
                            @click="resetDefaultSettingsForm">
                        {{ $t('reset') }}
                    </v-btn>
                    <v-btn
                            :disabled="!hasChangesSettings"
                            class="elevation-5  secondary--text mr-3"
                            color="primary"
                            large
                            @click="resetSettingsForm">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                            :disabled="!hasChangesSettings"
                            :loading="loading.Settings"
                            class="elevation-5 accentText--text"
                            color="accent"
                            large
                            @click="saveOrganization">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <LeaveConfirmDialog ref="leaveConfirmDialog"/>
    </div>
</template>

<script>
import {isEqual} from "@/helper/helper";
import LeaveConfirmDialog from "@/components/reusable/Dialog/LeaveConfirmDialog.vue";

export default {
  name: "MyOrganizations",
  components: {LeaveConfirmDialog},
  mounted() {
    this.initChannelConfiguration();
    this.initTimezones();
  },
  data() {
    return {
      validSettings: true,
      organization: {
        Name: this.$store.getters.selectedOrganization.Name,
        BackgroundColor: this.$store.getters.selectedOrganization.BackgroundColor ?? '#9E0D01',
        Color: this.$store.getters.selectedOrganization.Color ?? '#FFFFFF',
        LogoUrl: this.$store.getters.selectedOrganization.LogoUrl,
        Timezone: this.$store.getters.selectedOrganization.Timezone,
      },
      oldOrganization: {
        Name: this.$store.getters.selectedOrganization.Name,
        BackgroundColor: this.$store.getters.selectedOrganization.BackgroundColor ?? '#9E0D01',
        Color: this.$store.getters.selectedOrganization.Color ?? '#FFFFFF',
        LogoUrl: this.$store.getters.selectedOrganization.LogoUrl,
        Timezone: this.$store.getters.selectedOrganization.Timezone,
      },
      channelConfigurationsData: {
        Alert: {
          Email: {
            Info: false,
            Critical: false,
            Warning: false
          },
          SMS: {
            Info: false,
            Critical: false,
            Warning: false
          },
          Realtime: {
            Info: false,
            Critical: false,
            Warning: false
          },
        },
        Notification: {
          Email: {
            Info: false,
            Critical: false,
            Warning: false
          },
          SMS: {
            Info: false,
            Critical: false,
            Warning: false
          },
          Realtime: {
            Info: false,
            Critical: false,
            Warning: false
          },
        },
      },
      oldChannelConfigurationData: {},
      hasChangesSettings: false,
      isAdmin: this.$store.getters.isOrganizationAdmin,
      hasChanges: {
        Alert: false,
        Notification: false
      },
      loading: {
        Alert: false,
        Notification: false,
        Settings: false,
      },
      timezones: [],
    };
  },
  watch: {
    organization: {
      handler() {
        this.hasChangesSettings = !isEqual(this.organization, this.oldOrganization);
      },
      deep: true
    },
    channelConfigurationsData: {
      handler() {
        this.hasChanges.Alert = !isEqual(this.channelConfigurationsData['Alert'], this.oldChannelConfigurationData['Alert']);
        this.hasChanges.Notification = !isEqual(this.channelConfigurationsData['Notification'], this.oldChannelConfigurationData['Notification']);
      },
      deep: true
    },
  },
  computed: {
    isResetForm() {
      return this.organization.Color !== '#FFFFFF' || this.organization.BackgroundColor !== '#9E0D01' || this.organization.LogoUrl;
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    },
    selectedOrganization() {
      return this.$store.getters.selectedOrganization;
    },
    organizations() {
      return this.$store.getters.getOrganizations;
    },
    channelConfigurations() {
      return [
        {
          type: 'Alert',
          label: this.$t('settings.alerts')
        },
        {
          type: 'Notification',
          label: this.$t('menu.notifications')
        },
      ];
    }
  },
  methods: {
    setColor() {
      this.color = this.organization.color;
    },
    initChannelConfiguration() {
      const url = this.$store.getters.channelConfiguration;
      this.axios.get(url).then(({data}) => {
        const res = {...data.Result};
        this.oldChannelConfigurationData = JSON.parse(JSON.stringify(this.channelConfigurationsData));
        for (let i = 0; i < data.Result.length; i++) {
          this.channelConfigurationsData[res[i].Type][res[i].Channel][res[i].Severity] = true;
          this.oldChannelConfigurationData[res[i].Type][res[i].Channel][res[i].Severity] = true;
        }
      });
    },
    resetSettingsForm() {
      this.organization = {...this.oldOrganization};
    },
    resetPasswordForm() {
      this.password = {...this.oldPassword};
    },
    saveOrganization() {
      this.$refs.settingsForm.validate();
      if (!this.validSettings || !this.hasChangesSettings) {
        return;
      }

      let url = this.$store.getters.organization(this.$store.getters.getOrganizationId);
      this.loading.Settings = true;
      this.axios.patch(url, this.organization, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: this.$t('success.organizationWasUpdated')
            });

        url = this.$store.getters.getUrl('organizations');
        this.axios.get(url).then(({data}) => {
          this.$store.dispatch('setOrganizations', data.Result);
        });
        this.oldOrganization = {...this.organization};
        this.hasChangesSettings = false;
      }).finally(() => {
        this.loading.Settings = false;
      });
    },
    removeLogo() {
      this.organization.Logo = null;
      this.organization.LogoUrl = '';
    },
    uploadFile(files) {
      const [file] = files.target.files;
      if (file) {
        this.organization.LogoUrl = URL.createObjectURL(file);
        this.organization.Logo = file;
      }
    },
    leaveOrganization() {
      let url = this.$store.getters.leaveOrganization(this.selectedOrganization);
      this.axios.delete(url).then(() => {
        url = this.$store.getters.getUrl('organizations');
        this.axios.get(url).then(({data}) => {
          this.$store.dispatch('setOrganizations', data.Result);
        });
      });
    },
    selectOrganization() {
      this.$store.dispatch('setOrganizationId', this.selectedOrganization);
    },
    resetChannelConfiguration(type) {
      this.channelConfigurationsData[type] = JSON.parse(JSON.stringify(this.oldChannelConfigurationData[type]));
    },
    saveChannelConfiguration(type) {
      let values = [];
      let otherType = 'Alert';
      if (type === 'Alert') {
        otherType = 'Notification';
      }
      for (const [channelKey, channelValue] of Object.entries(this.channelConfigurationsData[type])) {
        for (const [severityKey, value] of Object.entries(channelValue)) {
          if (value) {
            values.push({
              Type: type,
              Channel: channelKey,
              Severity: severityKey
            });
          }
          // Use the old data for the other type, because we want to save the changes only for the selected type.
          if (this.oldChannelConfigurationData[otherType][channelKey][severityKey]) {
            values.push({
              Type: otherType,
              Channel: channelKey,
              Severity: severityKey
            });
          }
        }
      }
      const url = this.$store.getters.channelConfiguration;
      this.loading[type] = true;
      this.axios.put(url, values).then(() => {
        this.oldChannelConfigurationData[type] = JSON.parse(JSON.stringify(this.channelConfigurationsData[type]));
        this.hasChanges[type] = false;
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: type === 'Alert' ? this.$t('success.alertsWasUpdated') : this.$t('success.notificationsWasUpdated')
            });
      }).finally(() => {
        this.loading[type] = false;
      });
    },
    resetDefaultSettingsForm() {
      this.organization.Logo = null;
      this.organization.LogoUrl = '';
      this.organization.Color = '#FFFFFF';
      this.organization.BackgroundColor = '#9E0D01';
    },
    initTimezones() {
      const url = this.$store.getters.getUrl('timezones');
      this.axios.get(url).then(({data}) => {
        this.timezones = data.Result;
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges.Alert || this.hasChanges.Notification || this.hasChangesSettings) {
      this.$refs.leaveConfirmDialog.openDialog().then((res) => {
        if (res) {
          next();
        }
        this.next = next;
        next(false);
      });
    } else {
      return next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "my-organizations";
</style>